import createIcon from '../../createIcon';

/**
 * @component @name Deblur
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,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)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Deblur = createIcon('Deblur', [
  [
    'path',
    { d: 'M12.25 3V21C17.22 21 21.25 16.97 21.25 12C21.25 7.03 17.22 3 12.25 3Z', key: '15qpcr' },
  ],
  [
    'path',
    {
      d: 'M6.25 15C6.80228 15 7.25 14.5523 7.25 14C7.25 13.4477 6.80228 13 6.25 13C5.69772 13 5.25 13.4477 5.25 14C5.25 14.5523 5.69772 15 6.25 15Z',
      key: '1l7n7b',
    },
  ],
  [
    'path',
    {
      d: 'M6.25 19C6.80228 19 7.25 18.5523 7.25 18C7.25 17.4477 6.80228 17 6.25 17C5.69772 17 5.25 17.4477 5.25 18C5.25 18.5523 5.69772 19 6.25 19Z',
      key: 'z1n1vs',
    },
  ],
  [
    'path',
    {
      d: 'M6.25 11C6.80228 11 7.25 10.5523 7.25 10C7.25 9.44772 6.80228 9 6.25 9C5.69772 9 5.25 9.44772 5.25 10C5.25 10.5523 5.69772 11 6.25 11Z',
      key: 'ybqnzr',
    },
  ],
  [
    'path',
    {
      d: 'M3.25 10.5C3.52614 10.5 3.75 10.2761 3.75 10C3.75 9.72386 3.52614 9.5 3.25 9.5C2.97386 9.5 2.75 9.72386 2.75 10C2.75 10.2761 2.97386 10.5 3.25 10.5Z',
      key: '1ezl6w',
    },
  ],
  [
    'path',
    {
      d: 'M6.25 7C6.80228 7 7.25 6.55228 7.25 6C7.25 5.44772 6.80228 5 6.25 5C5.69772 5 5.25 5.44772 5.25 6C5.25 6.55228 5.69772 7 6.25 7Z',
      key: '1srxrz',
    },
  ],
  [
    'path',
    {
      d: 'M3.25 14.5C3.52614 14.5 3.75 14.2761 3.75 14C3.75 13.7239 3.52614 13.5 3.25 13.5C2.97386 13.5 2.75 13.7239 2.75 14C2.75 14.2761 2.97386 14.5 3.25 14.5Z',
      key: '1xfime',
    },
  ],
  [
    'path',
    {
      d: 'M10.25 21.5C10.5261 21.5 10.75 21.2761 10.75 21C10.75 20.7239 10.5261 20.5 10.25 20.5C9.97386 20.5 9.75 20.7239 9.75 21C9.75 21.2761 9.97386 21.5 10.25 21.5Z',
      key: 'lnhhju',
    },
  ],
  [
    'path',
    {
      d: 'M10.25 3.5C10.5261 3.5 10.75 3.27614 10.75 3C10.75 2.72386 10.5261 2.5 10.25 2.5C9.97386 2.5 9.75 2.72386 9.75 3C9.75 3.27614 9.97386 3.5 10.25 3.5Z',
      key: '1kuzgs',
    },
  ],
  [
    'path',
    {
      d: 'M10.25 7C10.8023 7 11.25 6.55228 11.25 6C11.25 5.44772 10.8023 5 10.25 5C9.69772 5 9.25 5.44772 9.25 6C9.25 6.55228 9.69772 7 10.25 7Z',
      key: '19cpda',
    },
  ],
  [
    'path',
    {
      d: 'M10.25 15.5C11.0784 15.5 11.75 14.8284 11.75 14C11.75 13.1716 11.0784 12.5 10.25 12.5C9.42157 12.5 8.75 13.1716 8.75 14C8.75 14.8284 9.42157 15.5 10.25 15.5Z',
      key: 'law5h7',
    },
  ],
  [
    'path',
    {
      d: 'M10.25 11.5C11.0784 11.5 11.75 10.8284 11.75 10C11.75 9.17157 11.0784 8.5 10.25 8.5C9.42157 8.5 8.75 9.17157 8.75 10C8.75 10.8284 9.42157 11.5 10.25 11.5Z',
      key: '1767pc',
    },
  ],
  [
    'path',
    {
      d: 'M10.25 19C10.8023 19 11.25 18.5523 11.25 18C11.25 17.4477 10.8023 17 10.25 17C9.69772 17 9.25 17.4477 9.25 18C9.25 18.5523 9.69772 19 10.25 19Z',
      key: '1sx3jp',
    },
  ],
]);

export default Deblur;
